import React from "react";
import Link from "next/link";
import useSubscriptionExperiments from "@shared/hooks/useSubscriptionExperiments";

interface Props {
  links:
    | {
        title: string;
        address: string;
      }[]
    | null
    | undefined;
}
const Links: React.FC<Props> = ({ links }) => {
  const { handleLogExperimentSubRecommender } = useSubscriptionExperiments();

  return (
    <div className="border-y border-y-zinc-200 sm:flex grid grid-cols-2 sm:flex-row sm:flex-wrap w-full  justify-center  py-5 gap-x-8 gap-y-4 max-w-[1920px]   px-6 md:px-[64px] lg:px-fds-120 xl:px-[64px] mx-aut ">
      {links?.map((link, index) => {
        const isItSubLink = link.title.includes("اشتراک فرادرس");
        return (
          <Link
            href={link.address}
            prefetch={false}
            key={index}
            target="_blank"
            onClick={() => {
              if (isItSubLink)
                handleLogExperimentSubRecommender({ position: "footer-links" });
            }}
          >
            <span className="text-sm font-normal whitespace-nowrap leading-7 text-[#52565C] hover:text-zinc-800 cursor-pointer">
              {link.title}
            </span>
          </Link>
        );
      })}
    </div>
  );
};

export default Links;
